import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useScope } from "@state/scopeContext.lib";
import { useUpdateClientEntityMutation } from "@api/organizationClient.api";
import { OrganizationServicesOffered } from "@common/types/organization";
import {
    SERVICE_OPTIONS,
    servicesOfferedLabels,
} from "@components/entity/constants";
import { Picker } from "@design-system/Picker/Picker.lib";
import { ClientDetailsRow } from "../clientViewConfig";
import { EMPTY_CELL_VALUE } from "./lib";

export const ServicesCell = ({
    row,
}: CellContext<
    ViewTableFeatures,
    ClientDetailsRow,
    OrganizationServicesOffered[]
>) => {
    const { organizationId } = useScope();
    const updateEntity = useUpdateClientEntityMutation();

    if (row.original.type === "workspace") {
        return EMPTY_CELL_VALUE;
    }

    const workspace = row.getParentRow()?.original;
    const entityId = row.original.id;

    if (!entityId || !organizationId || !workspace) {
        return null;
    }

    const selectedServices = row.original.services ?? [];
    const displayText = selectedServices
        .map((s) => servicesOfferedLabels[s])
        .join(", ");

    return (
        <ViewTableCell captureClicks>
            <Picker.Select
                multiple
                value={selectedServices}
                onValueChange={(value) =>
                    updateEntity.mutate({
                        organizationId,
                        clientId: workspace.id,
                        entityId: Number(entityId),
                        payload: { services: value },
                    })
                }
            >
                <Picker.CellContent
                    value={displayText || undefined}
                    addText="Set services"
                    hideAddIcon
                />
                <Picker.Popup>
                    <Picker.List>
                        {SERVICE_OPTIONS.map((option) => (
                            <Picker.Item
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </Picker.Item>
                        ))}
                    </Picker.List>
                </Picker.Popup>
            </Picker.Select>
        </ViewTableCell>
    );
};
